import React from "react";
import { object, number } from "prop-types";

import StoryHeader from "../story-header";
import StoryElements from "../story-elements";
import StorySideBar from "../story-sidebar";

import "./listcle.m.css";

const ListcleStoryTemplate = ({ story, index }) => {
  return (
    <>
      <div styleName="story-wrapper">
        <div className="story-section">
          <div>
            <StoryHeader story={story} />
            <StoryElements story={story} cards={story.cards} index={index} isPodcast />
          </div>
        </div>

        <div className="side-story-section hide-mobile">
          <StorySideBar index={index} story={story} />
        </div>
      </div>
    </>
  );
};

ListcleStoryTemplate.propTypes = {
  story: object,
  index: number
};

const ListcleStory = (props) => {
  return <ListcleStoryTemplate story={props.story} index={props.index} />;
};

ListcleStory.propTypes = {
  story: object,
  index: number
};

export default ListcleStory;
